import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface FinanceTotalData {
  totalDue: number;
  totalPending: number;
  totalPaid: number;
}
export interface FinanceProps {
  totalData: FinanceTotalData;
}

const initialState: FinanceProps = {
  totalData: {
    totalDue: 0,
    totalPending: 0,
    totalPaid: 0,
  },
};

export const financialSlice = createSlice({
  name: "finance",
  initialState,
  reducers: {
    setTotalData: (state, action: PayloadAction<FinanceTotalData>) => {
      state.totalData = action.payload;
    },
    resetFinancePropsState: () => initialState,
  },
});

export const { setTotalData, resetFinancePropsState } = financialSlice.actions;

export default financialSlice.reducer;
